









































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import gql from 'graphql-tag';
import store from '@/store';
import { parseError, UNKNOWN_ERROR } from '@/utils/errors.ts';
import ForgotPassword from '@/components/ForgotPassword.vue';

const loginMutation = gql`
  mutation Login($usernameOrEmail: String!, $password: String!) {
    getAuthToken(usernameOrEmail: $usernameOrEmail, password: $password)
  }
`;
@Component({
  components: {
    ForgotPassword,
  },
})
export default class Login extends Vue {
  public usernameOrEmail: string | null = null;
  public password: string | null = null;
  private fieldErrors: {[key: string]: string} = {};
  private formError: string | null = null;
  private forgotPasswordMode = false;

  private loading = false;

  public login() {
    this.validateFields();
    if (this.hasErrors) {
      return;
    }

    this.loading = true;
    this.$apollo.mutate({
      mutation: loginMutation,
      variables: { usernameOrEmail: this.usernameOrEmail, password: this.password },
    }).then((response) => {
      if (!response.data.getAuthToken) {
        this.loading = false;
        this.formError = 'Your username or password is incorrect.';
        return;
      }

      this.$store.dispatch('auth/setAuthToken', response.data.getAuthToken);
      this.$emit('done');

      this.loading = false;
    }).catch((e) => {
      this.formError = parseError(e) || UNKNOWN_ERROR;
      this.loading = false;
    });
  }

  get hasErrors() {
    return Object.values(this.fieldErrors).some((v) => v != null && v.length > 0);
  }

  public validateFields() {
    this.validateUsernameOrEmail();
    this.validatePassword();
  }

  public validateUsernameOrEmail() {
    const v = (this.usernameOrEmail || '').trim();

    let err = null;
    if (v.length < 1) {
      err = `Your username is required.`;
    }

    Vue.set(this.fieldErrors, 'usernameOrEmail', err);
  }

  public validatePassword() {
    const v = (this.password || '').trim();

    let err = null;
    if (v.length < 1) {
      err = `Your password is required.`;
    }

    Vue.set(this.fieldErrors, 'password', err);
  }

  @Watch('password')
  public onPasswordChange() {
    this.validatePassword();
  }

  @Watch('usernameOrEmail')
  public onUsernameOrEmailChange(val: string) {
    this.validateUsernameOrEmail();
  }
}
